import { default as indexslhkfp9gdDMeta } from "/root/workspace/edu-cert-plat-fe_6hRV/src/pages/index.vue?macro=true";
import { default as IndexF1wSVfh9ncMeta } from "@/src/pages-modules/cert-detail/Index.vue?macro=true";
import { default as IndexJEVW6GtsVHMeta } from "@/src/pages-modules/joint/Index.vue?macro=true";
import { default as IndexHMgDpGPfUNMeta } from "@/src/pages-modules/cert-evaluate/Index.vue?macro=true";
import { default as Indext7rFwpIZwiMeta } from "@/src/pages-modules/cert-list/Index.vue?macro=true";
export default [
  {
    name: indexslhkfp9gdDMeta?.name ?? "index",
    path: indexslhkfp9gdDMeta?.path ?? "/",
    meta: indexslhkfp9gdDMeta || {},
    alias: indexslhkfp9gdDMeta?.alias || [],
    redirect: indexslhkfp9gdDMeta?.redirect,
    component: () => import("/root/workspace/edu-cert-plat-fe_6hRV/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: IndexF1wSVfh9ncMeta?.name ?? "cert-detail",
    path: IndexF1wSVfh9ncMeta?.path ?? "/d_:certId(\\d+).html",
    meta: IndexF1wSVfh9ncMeta || {},
    alias: IndexF1wSVfh9ncMeta?.alias || [],
    redirect: IndexF1wSVfh9ncMeta?.redirect,
    component: () => import("@/src/pages-modules/cert-detail/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexF1wSVfh9ncMeta?.name ?? "cert-detail-with-level",
    path: IndexF1wSVfh9ncMeta?.path ?? "/d_:certId(\\d+)_:levelId(\\d+).html",
    meta: IndexF1wSVfh9ncMeta || {},
    alias: IndexF1wSVfh9ncMeta?.alias || [],
    redirect: IndexF1wSVfh9ncMeta?.redirect,
    component: () => import("@/src/pages-modules/cert-detail/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexJEVW6GtsVHMeta?.name ?? "joint",
    path: IndexJEVW6GtsVHMeta?.path ?? "/j_:id(\\d+).html",
    meta: IndexJEVW6GtsVHMeta || {},
    alias: IndexJEVW6GtsVHMeta?.alias || [],
    redirect: IndexJEVW6GtsVHMeta?.redirect,
    component: () => import("@/src/pages-modules/joint/Index.vue").then(m => m.default || m)
  },
  {
    name: IndexHMgDpGPfUNMeta?.name ?? "cert-evaluate",
    path: IndexHMgDpGPfUNMeta?.path ?? "/e_:certId(\\d*)_:lecId(\\d*).html",
    meta: IndexHMgDpGPfUNMeta || {},
    alias: IndexHMgDpGPfUNMeta?.alias || [],
    redirect: IndexHMgDpGPfUNMeta?.redirect,
    component: () => import("@/src/pages-modules/cert-evaluate/Index.vue").then(m => m.default || m)
  },
  {
    name: Indext7rFwpIZwiMeta?.name ?? "cert-list",
    path: Indext7rFwpIZwiMeta?.path ?? "/l:listParams([_|\\d|a-z]*).html",
    meta: Indext7rFwpIZwiMeta || {},
    alias: Indext7rFwpIZwiMeta?.alias || [],
    redirect: Indext7rFwpIZwiMeta?.redirect,
    component: () => import("@/src/pages-modules/cert-list/Index.vue").then(m => m.default || m)
  }
]